module.exports = __webpack_public_path__ + "img/expert-1.30fe76be.png";